import React from 'react';
import { useTranslation } from 'react-i18next';
import DatePickerField from './DatePickerField';
import TimePickerField from './TimePickerField';

const DateTimeField = ({ value, onChange, inputClass }) => {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-[57px] space-y-0.5">
      <div className="w-full">
        <label className="block text-sm font-medium text-gray-200 mb-1 mt-1">
          {t('jobs.serviceDate')}
        </label>
        <DatePickerField
          value={value?.date || ''}
          onChange={(date) => onChange({ ...value, date })}
          inputClass={inputClass}
          placeholder="dd.mm.yyyy"
        />
      </div>
      <div className="w-full">
        <label className="block text-sm font-medium text-gray-200 mb-1 mt-1">
          {t('jobs.serviceTime')}
        </label>
        <TimePickerField
          value={value?.time || ''}
          onChange={(time) => onChange({ ...value, time })}
          inputClass={inputClass}
          placeholder="HH:MM"
        />
      </div>
    </div>
  );
};

export default DateTimeField;


